import { Support, AjaxStdResponse, BsModal, Blocker } from './TS_Controls'

import { NameValueDTO } from './TS_Classes'




interface CalendarConfig {
    Panel?: string;
    ModalPanel?: string;
    Endpoint?: string;
    InsertPanel?: string;
    Location?: string;
    // BlockerConfig?: BlockerConfig;
}


/*
I'M MAKING THIS OBJECT A CLASS INSTEAD OF AN INTERFACE,
SO IT WILL BE CONSTRUCTED WITH ALL THE DEFAULT VALUES ON ALL ITS PROPERTIES,
BECAUSE WE NEED THESE PROPERTIES TO EXIST SO THEY CAN BE OBSERVED, OTHERWISE WITH A 
REGULAR JSON OBJECT WE WOULDN'T HAVE ANY PROPERTY TO OBSERVE.
*/
class CalendarRequest {
    public Month: string = null;
    public Segment: string = null;
    public ClassType: string = null;
    public Instructor: string = null;
    public WeekOffset: number = 0;
    public WeekTicks?: number = 0;
    public Location?: string = null;
}



interface CalendarResposne extends AjaxStdResponse {
    Week?: WeekDTO;
    WeekTicks?: number;
    Months?: NameValueDTO[];
    ClassTypes?: NameValueDTO[];
    Instructors?: NameValueDTO[];
    Segments?: NameValueDTO[];
}


interface WeekDTO {
    Start?: Date;
    End?: Date;
    Days?: DayDTO[];
    WeekOf?: string;
}


class SegmentDTO {
    ClassType?: string = null;
    ClassDesc?: string = null;
    Instructor?: string = null;
    TimeRange?: string = null;
}


interface DayDTO {
    Day?: Date;
    DayOfWeek?: string;
    Position?: number;
    Morning?: SegmentDTO[];
    Afternoon?: SegmentDTO[];
    Evening?: SegmentDTO[];
}



export class TruFitCalendar {

    private _cfg: CalendarConfig;
    private _realm: string = 'calendar';
    private _mdl: BsModal;
    private _blk: Blocker;


    private _wdto: WeekDTO;

    // public InputObj: KnockoutObservableArray<CalendarResposne>;
    public Days: KnockoutObservableArray<DayDTO>;
    public DaySegments: KnockoutObservableArray<NameValueDTO>;
    public Months: KnockoutObservableArray<NameValueDTO>;
    public ClassTypes: KnockoutObservableArray<NameValueDTO>;
    public Instructors: KnockoutObservableArray<NameValueDTO>;
    public WeekOf: KnockoutObservable<string>;

    // public Months: KnockoutObservableArray<NameValueDTO>;
    public FilterObj: KnockoutObservableType<CalendarRequest>;


    constructor(cfg: CalendarConfig) {
        this._cfg = cfg;
        this._mdl = new BsModal({
            Panel: cfg.ModalPanel,
        });
        this._blk = new Blocker();

        this.Load();
    }


    private PostError(msg: any) {
        this._mdl.Alert(msg, null, "Error :(");
    };



    private Load(): void {


        if (this._loaded) {
            /// WILL NOT BLOCK THE FIRST TIME AROUND, SO IT WILL NOT DISTURB THE VIEW OF THE PAGE.
            /// IT WILL BLOCK ONCE A NEW LOAD-REQUEST IS ISSUED.
            this._blk.Block();
        }

        
        
        if (!this._loaded) {
            /// CREATING AN EMPTY CalendarRequest ONLY THE FIRST TIME
            /// AROUND, AFTERWARDS I NEED TO USE THE EXISTING OBJECT

            let fltr = new CalendarRequest();

            /// PASSING THE LOCATION NAME (IF ANY WAS SPECIFIED)
            /// TO THE CALENDAR FILTER.
            fltr.Location = this._cfg.Location;

            this.FilterObj = ko.mapping.fromJS(fltr);
        }


        let obj = ko.mapping.toJS(this.FilterObj);

        Support.Post<CalendarResposne>(
            this._cfg.Endpoint + "?action=load&realm=" + this._realm,
            obj,
        ).then((accept) => {

            this.Loaded(accept);
            // console.log("SAVED!", accept);

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });
    }



    private _loaded: boolean = false;
    private Loaded(resp: CalendarResposne): void {

        if (!this._loaded) {

            /// MAPPING DATA THE FIRST TIME AROUND.
            ///    
            // this.InputObj = ko.mapping.fromJS(resp) as any;
            this.Days = ko.mapping.fromJS(resp.Week.Days) as any;
            this.DaySegments = ko.mapping.fromJS(resp.Segments) as any;
            this.Months = ko.mapping.fromJS(resp.Months) as any;
            this.ClassTypes = ko.mapping.fromJS(resp.ClassTypes) as any;
            this.Instructors = ko.mapping.fromJS(resp.Instructors) as any;

            this.WeekOf = ko.observable(resp.Week.WeekOf);

            /// MAKE SURE TO APPLY BINDINGS ONLY THE FIRST TIME AROUND.
            ko.applyBindings(this, $(this._cfg.Panel)[0]);

        } else {
            ko.mapping.fromJS(resp.Week.Days, this.Days) as any;

            this.WeekOf(resp.Week.WeekOf);
        }


        /// STORING THE CURRENT WEEK TICKS ON EVERY LOAD.
        ///
        this.FilterObj.WeekTicks = ko.observable(resp.WeekTicks);
        this.FilterObj.WeekOffset = ko.observable(0);

        this._loaded = true;
    }



    public GetDaySegment(segment: KnockoutObservableType<NameValueDTO>, day: DayDTO):
        KnockoutObservableArray<SegmentDTO> {

        var segName = segment.N();
        // console.log(segment.N());
        // return null;
        let rval: SegmentDTO[];

        if (segName == "Morning") {
            rval = day.Morning;
        } else if (segName == "Afternoon") {
            rval = day.Afternoon;
        } else if (segName == "Evening") {
            rval = day.Evening;
        } else {
            throw 'segment unsupported: ' + segName;
        }

        return ko.mapping.fromJS(rval) as any;
    }


    public TodayClass(position: number): string {
        let rval: string;
        if (position < 0) {
            rval = "as-cal-old";
        } else if (position == 0) {
            rval = "as-cal-curr";
        }
        return rval;
    }


    private _to: number;
    public Filter(): void {

        if (!this._loaded) {
            /*
             REJECTING THE CALLS TO THIS METHOD IF THE LOADED FLAG IS NOT TRUE YET.
             THIS IS BECAUSE THE FIRST TIME WE BIND THE DROP DOWNS, THIS EVENT WILL FIRE
             MULTIPLE TIMES, AND WE DON'T WANT TO LISTED TO IT INITIALLY.
             */
            return;
        }

        console.log("Filter requested...");

        clearTimeout(this._to);

        this._to = setTimeout(() => {

            this.Load();

        }, 500);
        // this.Load();
    }


    public NextWeek(): void {
        this.FilterObj.WeekOffset(1);
        this.Load();
    }

    public PrevWeek(): void {
        this.FilterObj.WeekOffset(-1);
        this.Load();
    }


}














ko.bindingHandlers.bspopover = {
    init: function (element, valueAccessor, allBindingsAccessor) {


        if (valueAccessor) {
            let va = valueAccessor() as KnockoutObservableType<SegmentDTO>;
            if (va) {

                let seg: SegmentDTO = ko.mapping.toJS(va) as SegmentDTO;

                var pop = new BsPopover({
                    Dom: element,
                    Segment: seg,
                });
                pop.Draw();
            }
        }


    },

};















interface BsPopoverConfig {
    Panel?: string;
    Dom?: Element;
    Segment?: SegmentDTO;
    // DateChanged?: (sender: DateTimePicker, newDate: string) => void;
}





export class BsPopover {

    private _cfg: BsPopoverConfig;

    constructor(cfg: BsPopoverConfig) {
        this._cfg = cfg;
    }


    public Draw(): void {

        let seg: SegmentDTO = (this._cfg.Segment) ? this._cfg.Segment : new SegmentDTO();

        let template: string =
            `<div class="popover as-popover" role="tooltip">
                <div class="popover-arrow"></div>
                <div class="as-popover-class">
                    ${seg.ClassType}
                </div>
                <div class="as-popover-instructor">${seg.Instructor}</div>
                <div class="as-popover-schedule">${seg.TimeRange}</div>
                <hr>
                <div class="as-popover-description">
                    ${seg.ClassDesc}
                </div>
            </div >`;

        let pnl = $(this._cfg.Panel);
        if (pnl.length == 0) pnl = $(this._cfg.Dom);

        if (pnl.length == 0)
            throw "Didn't find the panel to display the Popover";


        (pnl as any).popover({
            trigger: 'hover',
            title: 'some title',
            template: template
        });


    }



}







// WEBPACK FOOTER //
// ./js/TS_Calendar.ts